<div class="list-holder">
	<h2>{{ title }}</h2>
	<table class="item-table">
		<tr>
			<th>No.</th>
			<th>Item</th>
			<th>Qty</th>
			<th>Unit</th>
		</tr>
		<tr *ngFor="let item of items">
			<td>{{ item.no }}</td>
			<td class="name-holder">{{ item.name }}</td>
			<td>{{ item.quantity }}</td>
			<td>{{ item.measurement }}</td>
			<td>
				<img
					(click)="removeFromList(item.no)"
					src="{{ itemButtonLabel }}"
					class="icon-btn"
					alt=""
				/>
			</td>
		</tr>
		<tr [hidden]="!isLogItem">
			<td>{{ items.length + 1 }}</td>
			<td>
				<input
					class="name-input"
					#name
					type="text"
					placeholder="Name"
					name=""
					id=""
				/>
			</td>
			<td>
				<input
					class="number-input"
					#quantity
					placeholder="00"
					type="number"
					name=""
					id=""
				/>
			</td>
			<td>
				<input
					class="unit-input"
					placeholder="packs, etc."
					#measurement
					type="text"
					name=""
					id=""
				/>
			</td>
			<td>
				<img
					(click)="addItem(name, quantity, measurement)"
					src="/assets/common/plus.png"
					class="icon-btn"
					alt=""
				/>
			</td>
		</tr>
	</table>
	<button [hidden]="!isLogItem" (click)="closeList()" class="btn-style">
		Complete
	</button>
</div>
